export default "__VITE_ASSET__B6W7gfX3__"